import ApplicationConf from 'conf/ApplicationConf'
import { callPromisesSequentially, checkAuth, checkError, genericFetch, genericPromise2, getAuthorization, getJson, promiseAllProgress } from 'utils/ActionUtils'
// import i18n from 'simple-react-i18n'
import { QualityActionConstant } from 'quality/reducers/QualityReducer'
// import LogAction from 'log/actions/LogAction'
// import ToastrAction from 'toastr/actions/ToastrAction'
import { chunk, flatten, zip } from 'lodash'

const AnalysisAction = {
    promiseAnalysis: (filter, signal) => {
        return fetch(ApplicationConf.analysis.default(), {
            method: 'POST',
            headers: getAuthorization(),
            body: JSON.stringify(filter),
            signal,
        }).then(checkAuth).then(getJson).then(checkError)
    },
    getAllAnalysisSeq: (filter, signal, progressCallback = () => {}, cb = () => {}) => () => {
        const [promises, params] = (() => {
            const { stations, ...searchFilter } = filter
            if (stations) {
                const groupSize = Math.min(Math.floor(stations.length / 10), 10)
                return zip(...chunk(stations, groupSize > 0 ? groupSize : 1).map(s => [AnalysisAction.promiseAnalysis, [{ ...searchFilter, stations: s }, signal]]))
            }
            return zip(...[AnalysisAction.promiseAnalysis, [searchFilter, signal]])
        })()
        return callPromisesSequentially(promises, params, progressCallback, json => cb(flatten(json)))
    },

    // eslint-disable-next-line valid-jsdoc
    /**
     * @deprecated use getAllAnalysisSeq
     */
    getAnalysis: (filter, signal) => genericPromise2(ApplicationConf.analysis.default(), { method: 'POST', body: filter, signal }).catch((err) => {
        if (err.name === 'AbortError') return
        console.error('An error happened while fetching analysis')
    }),
    fetchGenericAnalysis: (filter, signal) => genericFetch(AnalysisAction.getAnalysis(filter, signal), 'POST'),
    fetchAnalysis: (filter = {}, signal, onProgress = () => {}) => dispatch => {
        const {
            stations,
            ...searchFilter
        } = filter
        const group = Math.floor(stations.length / 25)
        const promises = chunk(stations, group > 0 ? group : 1).map(stationsGroup => genericPromise2(ApplicationConf.analysis.default(), { method: 'POST', body: { ...searchFilter, stations: stationsGroup }, signal })
            .catch(() => []))
        return promiseAllProgress(promises, onProgress)
            .then(jsonTab => {
                if (signal.aborted) {
                    return 0
                }
                const results = flatten(jsonTab)
                dispatch(QualityActionConstant.receiveSearchAnalysis(results))
                return results.length
            })
    },

    getLastOperationAnalysis: (ids, date, signal) => genericPromise2(ApplicationConf.qualitometer.lastOperationAnalysis(ids, date), { method: 'GET', signal }),

    getControledAnalysis: (controlType = {}, filters = {}, signal) => genericPromise2(ApplicationConf.analysis.control(), { method: 'POST', body: { ...controlType, filters }, signal }),
}

export default AnalysisAction